import { render, staticRenderFns } from "./NonAllowableAssetsView.vue?vue&type=template&id=edcf7c36"
import script from "./NonAllowableAssetsView.vue?vue&type=script&lang=js"
export * from "./NonAllowableAssetsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports